import { dateFilter, datePresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Filters',

  mixins: [ dateFilter, proxy({ type: 'object' }) ],

  data() {
    return {
      preset: datePresets.today
    }
  },

  render
}
